module.exports = __webpack_public_path__ + "img/72.50891c38.jpg";